import React, { useEffect, useRef, useState } from "react";
import "./ExpandableTextarea.css";
import { elakayAutoText } from "./dataElakay";


const ExpandableTextarea = ({
  id,
  label,
  value = "",
  onChange,
  required = false,
  placeholder,
  errorMessage,
  forceError = false,
  maxLength = 3000
}) => {
  const [focused, setFocused] = useState(false);
  const [touched, setTouched] = useState(false);
  const textareaRef = useRef(null);
  const expanded = focused || Boolean(value.trim());
  const invalid = required && !value.trim() && (touched || forceError);
  const errorId = `${id}-error`;

  useEffect(() => {
    if (focused && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [focused]);

  const handleBlur = () => {
    setFocused(false);
    setTouched(true);
  };

  return (
    <div className={`expandable-textarea ${expanded ? "expanded" : "collapsed"} ${invalid ? "invalid" : ""}`}>
      <label htmlFor={id}>
        <span>{label}</span>
        {required && <strong>{errorMessage?.requiredLabel || elakayAutoText("h_97cdc30b3ef1b9", "Required *")}</strong>}
      </label>
      <div className="expandable-textarea-control">
        {expanded ? (
          <textarea
            ref={textareaRef}
            id={id}
            value={value}
            rows={5}
            maxLength={maxLength}
            required={required}
            aria-invalid={invalid}
            aria-describedby={invalid ? errorId : undefined}
            placeholder={placeholder}
            onChange={(event) => onChange(event.target.value)}
            onFocus={() => setFocused(true)}
            onBlur={handleBlur}
          />
        ) : (
          <input
            id={id}
            type="text"
            value=""
            readOnly
            aria-invalid={invalid}
            aria-describedby={invalid ? errorId : undefined}
            placeholder={placeholder}
            onFocus={() => setFocused(true)}
            onClick={() => setFocused(true)}
          />
        )}
      </div>
      {invalid && <small id={errorId} role="alert">{errorMessage?.validation || elakayAutoText("h_74f3af6208bbc6", "This answer is required.")}</small>}
    </div>
  );
};

export default ExpandableTextarea;
